<template>
  <div
    class="flex w-full flex-col gap-y-4 px-8 py-4"
    data-testid="rx-step-prescription-values"
  >
    <form class="space-y-8 py-4" @submit.prevent>
      <RxSightPrescriptionValue
        v-for="currentStep in prescriptionFields"
        :key="currentStep.name"
        :name="currentStep.name"
        :unit="currentStep.unit"
        :validate="currentStep.validate"
        :options="currentStep.options"
        :min="currentStep.min"
        :max="currentStep.max"
        :is-optional="currentStep.isOptional"
        :step="currentStep.step"
        :storyblok-slug="currentStep.storyblokSlug"
      />
    </form>
  </div>
</template>

<script setup lang="ts">
import getPrescriptionSteps from '~/composables/rxConfig/PrescriptionFormConfig'

const emit = defineEmits(['ui:update'])

const $currentShop = useCurrentShop()
const prescriptionFields = getPrescriptionSteps($currentShop.value)
const { isPrescriptionValid } = await useRxConfiguratorState()

const scope = effectScope()
onScopeDispose(() => scope.stop())

onMounted(() => {
  emit('ui:update', {
    mainAction: 'continue',
    disabled: !isPrescriptionValid.value,
  })
})

scope?.run(() => {
  if (import.meta.server) {
    return
  }
  watch(isPrescriptionValid, () => {
    emit('ui:update', {
      disabled: !isPrescriptionValid.value,
    })
  })
})
</script>
